import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import ButtonLink from "../../../ButtonLink/ButtonLink"
import { BROWSE_SEARCH_PATH, BROWSE_SEARCH_URL } from "../../../../utils/paths"
import { bold, button, moyoSearchLink, noMargin } from "./styles.module.scss"

const careTypes = {
  care_home: "care homes",
  home_care: "care agencies",
}

const getMoyoSearchLink = (geoSelfPathData, isTownPage, careServiceType) => {
  const {
    locationName,
    careType,
    careHomeCount,
    homeCareCount,
  } = geoSelfPathData

  const careServiceTypeParam =
    careServiceType && careType === "care_home"
      ? `&care_provided[]=${careServiceType}`
      : ""

  if (
    isTownPage &&
    ((careType === "care_home" && careHomeCount > 10) ||
      (careType === "home_care" && homeCareCount > 10))
  ) {
    return `${BROWSE_SEARCH_PATH}?care_type=${careType}&location=${locationName}${careServiceTypeParam}`
  }
  if (careType === "home_care") {
    return `${BROWSE_SEARCH_URL}?care_type=home_care`
  }
  return BROWSE_SEARCH_URL
}

const getMoyoSearchText = (geoSelfPathData, isTownPage, careServiceType) => {
  const {
    locationName,
    careType,
    careHomeCount,
    homeCareCount,
  } = geoSelfPathData

  const careServiceTypeText = careServiceType ? `${careServiceType} ` : ""

  if (
    isTownPage &&
    ((careType === "care_home" && careHomeCount > 10) ||
      (careType === "home_care" && homeCareCount > 10))
  ) {
    return (
      <p className={classNames(noMargin)}>
        <span className={classNames(bold)}>
          View all {careServiceTypeText}
          {careTypes[careType]}
        </span>{" "}
        in {locationName}
      </p>
    )
  }

  return <span className={classNames(bold)}>Search for care near you</span>
}

const MoyoSearchLink = ({ geoSelfPathData, isTownPage, careServiceType }) => {
  const buttonLink = getMoyoSearchLink(
    geoSelfPathData,
    isTownPage,
    careServiceType,
  )
  const buttonText = getMoyoSearchText(
    geoSelfPathData,
    isTownPage,
    careServiceType,
  )
  const browseCtaClickEvent = {
    name: "SEO - Filtered Directory - Browse Button Clicked",
    properties: {
      "Target Path": buttonLink,
    },
  }

  return (
    <div className={classNames(moyoSearchLink)}>
      <ButtonLink
        className={classNames(button)}
        to={buttonLink}
        clickEvent={browseCtaClickEvent}
      >
        {buttonText}
      </ButtonLink>
    </div>
  )
}

MoyoSearchLink.propTypes = {
  geoSelfPathData: PropTypes.shape({
    locationName: PropTypes.string.isRequired,
    careHomeCount: PropTypes.number.isRequired,
    homeCareCount: PropTypes.number.isRequired,
    careType: PropTypes.oneOf(["home_care", "care_home"]),
  }).isRequired,
  isTownPage: PropTypes.bool.isRequired,
  careServiceType: PropTypes.oneOf(["dementia"]),
}

MoyoSearchLink.defaultProps = {
  careServiceType: undefined,
}

export default MoyoSearchLink
